import React, { useEffect, useRef, useState } from "react";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { useDataApiClient } from "../../hooks/useApiClient";
import {
  Box,
  HStack,
  Skeleton,
  SkeletonText,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

export const OutboundIpDetails = () => {
  const isMounted = useRef(true);
  const [outbound, setOutbound] = useState<[key: string]>();
  const apiClient = useDataApiClient();
  const setOutboundIpDetails = async () => {
    const result = await apiClient.getOutboundIpDetails();
    if (result.ok && isMounted.current) {
      setOutbound(result.data);
    }
  };

  useEffect(() => {
    setOutboundIpDetails();
  }, [isMounted]);

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Outbound Ip Details</PageHeading.Title>
      </PageHeading>
      <PageContent>
        {(outbound && (
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Field</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {Object.entries(outbound).map(([key, value]) => {
                return (
                  <Tr key={key}>
                    <Td>{key}</Td>
                    <Td>{value}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )) || (
          <HStack w="100%">
            <Box width="40%" padding="6" boxShadow="lg">
              <Skeleton height="40px" />
              <SkeletonText mt="4" noOfLines={12} spacing="4" />
            </Box>
            <Box width="60%" padding="6" boxShadow="lg">
              <Skeleton height="40px" />
              <SkeletonText mt="4" noOfLines={12} spacing="4" />
            </Box>
          </HStack>
        )}
      </PageContent>
    </>
  );
};
